// extracted by mini-css-extract-plugin
module.exports = {"external-link-wrapper":"ExternalLink_external-link-wrapper__1s3Eb"};